<template>
  <div>
    <div class="flex items-center">
      <condition-icon class="h-4 w-4" :class="isHighlighted || isFocused ? 'text-focus' : 'text-gray'"/>
      <p class="text-sm leading-none ml-1" :class="isHighlighted || isFocused ? 'text-focus' : 'text-gray'">Condition</p>
    </div>

    <div
      class="section-container mt-2 border border-solid rounded border-gray hover:cursor-pointer hover:border-focus"
      :class="sectionClasses"
      @click.self="() => selectConditionSection(selectedCaseIndex)">

      <div class="flex flex-wrap gap-2">
        <condition-case v-for="(conditionCase, i) of cases" :key="i"
                        :condition="conditionCase.condition"
                        :is-selected="i === selectedCaseIndex"
                        :is-condition-focused="isHighlighted || isFocused"
                        @select-case="() => selectConditionSection(i)"/>
      </div>
      <preview-item v-for="(item, i) of selectedCaseItems"
                    :conversation-id="conversationId"
                    :conversation-type="conversationType"
                    :answer-end-type="answerEndType"
                    :item="item"
                    :key="i"
                    :in-condition="true"
                    :in-nested-condition="inNestedCondition"
                    class="mt-3"
                    :class="{'test-condition-section-add-widget': item.type === PREVIEW_ITEM.ADD_WIDGET}"
      />
    </div>

  </div>
</template>

<script>
import ConditionIcon from '@/assets/images/icons/ConditionIcon'
import ConditionCase from './ConditionCase2'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import { PREVIEW_ITEM } from '@/store/constants'
import last from 'ramda/src/last'

export default {

  name: 'ConditionSection',

  components: {
    ConditionIcon,
    ConditionCase,
    PreviewItem: () => import('./PreviewItem') // async import to avoid issues with recursive components
  },

  props: {
    conversationId: { type: String, required: true },
    conversationType: { type: String, required: true },
    stateId: { type: String, required: true },
    cases: { type: Array, required: true },
    selectedCaseIndex: { type: Number, required: true },
    selectedCaseItems: { type: Array, required: true },
    isHighlighted: { type: Boolean, default: false },
    isTemplate: { type: Boolean, default: false },
    inNestedCondition: { type: Boolean, default: false }
  },

  data() {
    return {
      PREVIEW_ITEM
    }
  },

  computed: {
    collapseKey: chatBubbleModule.collapseKey,

    isFocused() {
      return chatBubbleModule.isConditionSectionFocused(this.stateId)
    },

    sectionClasses() {
      if (this.isHighlighted || this.isFocused) {
        return ['bubble-shadow', 'border-focus']
      }

      return ['']
    },

    answerEndType() {
      return last(this.selectedCaseItems).value
    }
  },

  methods: {
    selectConditionSection(selectedCaseIndex) {
      chatBubbleModule.selectConditionSection(this.stateId, selectedCaseIndex, this.isTemplate)
      this.collapseKey = Math.random()
    }
  }
}
</script>

<style scoped>
.section-container {
  padding: 0.75em;
}
</style>
